// Backdrop dismissal guard.
//
// On touch devices the browser dispatches `click` AFTER `touchend`, and the hit
// test happens at dispatch time. A tap that opens a sheet therefore lands its
// click on the freshly rendered backdrop, which instantly closed the sheet
// again ("opens and closes by itself"). This only dismisses when the pointer
// went DOWN on the backdrop itself, and never within a moment of opening.

import React from "react";

export function useBackdropDismiss(open, onDismiss, delay = 300) {
  const openedAt = React.useRef(0);
  const startedOnBackdrop = React.useRef(false);

  React.useEffect(() => {
    if (open) {
      openedAt.current = Date.now();
      startedOnBackdrop.current = false;
    }
  }, [open]);

  return {
    onPointerDown: (e) => {
      startedOnBackdrop.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      if (e.target !== e.currentTarget) return;
      if (!startedOnBackdrop.current) return;
      if (Date.now() - openedAt.current < delay) return;
      onDismiss();
    },
  };
}
